// filter to check for active or inactive status. Fixed by Alan 6/26/26
const statusFilter = (el, val, filterCol) => {
    if (val == 'Active'){
        return el[filterCol] == true;
    }
    else {
        return el[filterCol] == false;
    }
}

export default statusFilter;
